// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Pd","heading":"Qd"};